// removed by extract-text-webpack-plugin
module.exports = {"main":"battery-icon-main--1PMhc","level-0":"battery-icon-level-0--3r8PP","level-1":"battery-icon-level-1--36vuI","level-2":"battery-icon-level-2--2Q5Bw","level-3":"battery-icon-level-3--2v07m","level-4":"battery-icon-level-4--1Qf31","level-5":"battery-icon-level-5--1b5tP","level-6":"battery-icon-level-6--C7yh3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BatteryIcon/battery-icon.scss
// module id = mRdt
// module chunks = 4